// src/components/claims/SourcesPanel.jsx
//
// «Fonti consultate» — what the run consulted to write and check the text
// (results.sourcesConsulted, BE ≥ e162398): research passages and the sources only the
// fact check used (`origin: VERIFICATION`, so never «before writing»). Shared by the
// generator run card and the run detail page, next to ClaimsPanel.
// - Nothing to show (no titled source) → renders nothing.
// - Always starts CLOSED: nothing here needs action. Header chips count each kind.
// - One block per kind (claimsModel.groupSources: what the user brought first, then
//   what Brian found); an unknown kind is labelled with its code.
import React from 'react';
import { useTranslation } from 'react-i18next';
import { BookOpen } from 'lucide-react';
import CollapsiblePanel from './CollapsiblePanel.jsx';
import GroupBlock from './GroupBlock.jsx';
import SourceRow from './SourceRow.jsx';
import { groupSources } from './claimsModel.js';
import { RADII, SEMANTIC } from '../../constants/theme.js';

const kindLabel = (kind, tr) => (kind ? tr(`claims.sourceKind.${kind}`, { defaultValue: kind }) : tr('sources.unknownKind'));

function KindChip({ label, count }) {
  return (
    <span style={{
      display: 'inline-flex', whiteSpace: 'nowrap', padding: '2px 8px', borderRadius: RADII.pill,
      fontSize: '11px', fontWeight: 600, background: SEMANTIC.neutro.bg, color: SEMANTIC.neutro.fg,
    }}>
      {label} · {count}
    </span>
  );
}

export default function SourcesPanel({ results, t = {}, w = (o) => `rgba(0,0,0,${o})` }) {
  const { t: tr } = useTranslation('outputs');
  const groups = groupSources(results?.sourcesConsulted);
  if (groups.length === 0) return null;
  const chips = groups.map((g) => <KindChip key={g.kind ?? '-'} label={kindLabel(g.kind, tr)} count={g.sources.length} />);
  return (
    <CollapsiblePanel
      icon={BookOpen}
      title={tr('sources.title')}
      description={tr('sources.description')}
      chips={chips}
      bodyId={`sources-panel-${results?._taskId || 'run'}`}
      t={t}
      w={w}
    >
      {groups.map((g) => (
        <GroupBlock
          key={g.kind ?? '-'}
          label={kindLabel(g.kind, tr)}
          countText={tr('sources.groupCount', { count: g.sources.length })}
          t={t}
          w={w}
        >
          {g.sources.map((s, i) => <SourceRow key={s.id ?? i} source={s} t={t} />)}
        </GroupBlock>
      ))}
    </CollapsiblePanel>
  );
}
